import "../ProductSlider/HomeProduct.css";
import "../../Css/ProductCard.css";
import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
// With this single import:
import 'swiper/swiper-bundle.css';
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import 'swiper/css/navigation'; // Added Navigation CSS
import { Link } from "react-router-dom";
import { get } from "../../services/ApiRouting";
import HomePerfumeProduct from "../HomeCategory/HomePerfumeproduct.jsx";
import HomeClothProduct from "../HomeCategory/HomeClothProduct";
import HomeBagProduct from "../HomeCategory/HomeBagProduct";
import AtYourService from "../AtYourService";
import { PRODUCT_API_BASE_URL } from "../../services/apiConfig";


const HomeProduct = () => {
    const [productType, setProductType] = useState("all"); // Default to 'all'
    const [productData, setProductData] = useState([]);
    const [loading, setLoading] = useState(false);
    const swiperRef = useRef(null);
    const IMAGE_BASE_URL = 'https://1fiveglobal.in/uploads/productsImages/';
    // const fetchData = () => {
    //     let filteredData = [];
    //     switch (productType) {
    //         case "men":
    //             filteredData = AllData.filter((product) => product.product_type === "men");
    //             break;
    //         case "women":
    //             filteredData = AllData.filter((product) => product.product_type === "women");
    //             break;
    //         default:
    //             filteredData = AllData; // Show all products
    //     }
    //     setProductData(filteredData);
    // };

    const fetchData = async () => {
        setLoading(true)
        try {
            const response = await get(`${PRODUCT_API_BASE_URL}products?is_newest=1?status=active`);
            setLoading(false)
            setProductData(response?.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    console.log("productData", productData)

    useEffect(() => {
        fetchData();
    }, [productType]);


    return (
        <>
            <section className="Home-product-section-2">
                <div className="Home-product-head-con">
                    <div className="Home-product-head-title-con">
                        <h2>New <span>Arrivals</span></h2>
                    </div>
                    {/* <div className="Home-Product-select-tabs-con">
                        <div className="Home-Product-select-tabs">
                            <div
                                className={`Home-Product-select-tab ${productType == "all" ? "home-active-tab" : ""}`}
                                onClick={() => setProductType("all")}
                            >
                                <h3>All</h3>
                            </div>
                            <div
                                className={`Home-Product-select-tab ${productType == "women" ? "home-active-tab" : ""}`}
                                onClick={() => setProductType("women")}
                            >
                                <h3>Women</h3>
                            </div>
                            <div
                                className={`Home-Product-select-tab ${productType == "men" ? "home-active-tab" : ""}`}
                                onClick={() => setProductType("men")}
                            >
                                <h3>Men</h3>
                            </div>
                            <div
                                className={`Home-Product-select-tab ${productType == "accessories" ? "home-active-tab" : ""}`}
                                onClick={() => setProductType("accessories")}
                            >
                                <h3>Accessories</h3>
                            </div>
                        </div>
                    </div> */}
                </div>

                <div className="Home-Product-select-card-section-con">
                    <Swiper
                        key={`home-products-${productData.length}`}
                        slidesPerView={1}
                        spaceBetween={1}
                        loop={true}
                        watchOverflow={false}
                        pagination={{
                            clickable: true,
                        }}
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                        onInit={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                        /* Autoplay is omitted, keeping it completely OFF */
                        breakpoints={{
                            430: { slidesPerView: 2, spaceBetween: 1 },
                            640: { slidesPerView: 2, spaceBetween: 1 },
                            768: { slidesPerView: 3, spaceBetween: 1 },
                            1024: { slidesPerView: 4, spaceBetween: 1 },
                        }}
                        modules={[Pagination]}
                        className="mySwiper"
                    >
                        {productData?.map((product, productIndex) => {
                            const primaryImage = product?.images?.[0]?.image
                                ? `${IMAGE_BASE_URL}${product.images[0].image}`
                                : 'https://via.placeholder.com/300x400?text=No+Image';

                            const secondaryImage = product?.images?.[1]?.image
                                ? `${IMAGE_BASE_URL}${product.images[1].image}`
                                : primaryImage;
                            return (
                                <SwiperSlide key={productIndex}>
                                    <div className="product-card-main-con">
                                        <Link to={`/${product?.category_slug}/${product?.subcategory_slug}/${product?.slug}`}>
                                            <div className="product-card-body-con">
                                                <div className="product-card-Image-con product-item__image double__image new-product-item__bg">
                                                    <div className="product-item__bg">
                                                        <img
                                                            src={primaryImage}
                                                            alt={product?.name || 'Product'}
                                                        />
                                                    </div>
                                                    <div className="product-item__bg__under">
                                                        <img
                                                            src={secondaryImage}
                                                            alt={product?.name || 'Product Hover'}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="Product-card-details-con">
                                                    <div className="Product-card-details">
                                                        <div className="product-card-product-name">
                                                            <h4>{product.product_name}</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                    <button
                        type="button"
                        className="swiper-button-prev home-product-slider-prev"
                        onClick={() => swiperRef.current?.slidePrev()}
                        aria-label="Previous products"
                    ></button>
                    <button
                        type="button"
                        className="swiper-button-next home-product-slider-next"
                        onClick={() => swiperRef.current?.slideNext()}
                        aria-label="Next products"
                    ></button>
                </div>
            </section>



            {/* 1FIVE Accessories  */}
            <div className="home-page-divder-section-for-images-for-phone-view">
                <section className="home-page-divder-section-for-images">
                    <div className="home-page-divder-section-for-images-text-main-con">
                        <div className="home-page-divder-section-for-images-text">
                            <h3>The Art Of Detail</h3>
                        </div>
                    </div>
                </section>
            </div>

            <HomeBagProduct />


            {/* 1FIVE Fragrance  */}
            <div className="home-page-divder-section-for-images-for-phone-view">
                <section className="home-page-divder-section-for-images">
                    <div className="home-page-divder-section-for-images-text-main-con">
                        <div className="home-page-divder-section-for-images-text">
                            <h3>Not A Scent. A Signature.</h3>
                        </div>
                    </div>
                </section>
            </div>
            <HomePerfumeProduct />


            {/* 1FIVE Apparel  */}
            <div className="home-page-divder-section-for-images-for-phone-view">
                <section className="home-page-divder-section-for-images">
                    <div className="home-page-divder-section-for-images-text-main-con">
                        <div className="home-page-divder-section-for-images-text">
                            <h3>Tailored Without Limits.</h3>
                        </div>
                    </div>
                </section>
            </div>
            <HomeClothProduct />

            {/* 
            <section className="Home-Section-3 bg-image-one">

            </section> */}



            {/* end for perfume  */}

            {/* for cloth   */}

            <section className="Home-Section-3 bg-image-sixth">

            </section>

            <AtYourService />

            <section className="Home-Section-3 bg-image-second">

            </section>

            {/* end for cloths  */}

            {/* for bags  */}




            {/* <section className="Home-Section-3 bg-image-third">

            </section> */}

            {/* dddddddddddddddddddddddddddddddddddddddddddddd */}


            {/* <section className="Home-Section-3 bg-image-fourth">

            </section> */}

            {/* dddddddddddddddddddddddddddddddddddddddddddddd */}

            {/* <section className="home-page-divder-section-for-images">
                <div className="home-page-divder-section-for-images-text-main-con">
                    <div className="home-page-divder-section-for-images-text">
                        <h3>Shades of Black</h3>
                        <div class="txt" id="txt">
                            <b>1</b><b>F</b><b>I</b><b>V</b><b>E</b>
                        </div>
                    </div>
                </div>
                <div className="Home-Section-3-btn-con animation-btn">
                    <Link to="/men">
                        <button>
                            see the collection
                        </button>
                    </Link>
                </div>
            </section> */}

            {/* dddddddddddddddddddddddddddddddddddddddddddddd */}


            {/* <section className="Home-Section-3 bg-image-fifth">

            </section> */}

            {/* <section className="home-page-divder-section-for-images">
                <div className="home-page-divder-section-for-images-text-main-con">
                    <div className="home-page-divder-section-for-images-text">
                        <h4 className="shake">Dark Mode Accessories</h4>
                    </div>
                </div>
                <div className="Home-Section-3-btn-con">
                    <Link to="/Accessories">
                        <button>
                            see the collection
                        </button>
                    </Link>
                </div>
            </section> */}




            {/* dddddddddddddddddddddddddddddddddddddddddddddd */}

            {/* <section className="home-page-divder-section-for-images">
                <div className="home-page-divder-section-for-images-text-main-con">
                    <div className="home-page-divder-section-for-images-text">
                        <h4 className="blink_text">Elevate Your Look with Bold Black Accessories</h4>
                    </div>
                </div>
                <div className="Home-Section-3-btn-con">
                    <div className="Home-Section-3-btn-con">
                        <Link to="/Accessories">
                            <button>
                                see the collection
                            </button>
                        </Link>
                    </div>
                </div>
            </section> */}

            {/* dddddddddddddddddddddddddddddddddddddddddddddd */}

            {/* <section className="Home-Section-3 bg-image-seven">

            </section> */}

            {/* dddddddddddddddddddddddddddddddddddddddddddddd */}

            {/* <section className="home-page-divder-section-for-images">
                <div className="home-page-divder-section-for-images-text-main-con">
                    <div className="home-page-divder-section-for-images-text">
                        <h4 className="blink_text">Edgy, Bold, and Always in Black</h4>
                    </div>
                </div>
                <div className="Home-Section-3-btn-con">
                    <Link to="/men">
                        <button>
                            see the collection
                        </button>
                    </Link>
                </div>
            </section> */}

            {/* <section className="Home-Section-3 bg-image-eight">

            </section> */}

        </>
    );
};

export default HomeProduct;
